/* eslint-disable default-case */
import bridge from '@/config/JSbridge';
import  {Base64 }  from 'js-base64/base64.js';
import { deepClone} from './wogoo_utils'
import bwmodel from '@/config/bwmodel'
import { uploadTrace } from '@/api/base'
import NodeRSA from 'node-rsa';
const ua = navigator.userAgent

function testValueStorm () {
  if(/ValueStorm/i.test(ua)) {
    return true;
  }
  return false;
}

export const isStorm = testValueStorm();
/**
 * 页面跳转使用客户端跳转方式
 * @param {*} url
 */
export const jumpTo = (url) => {

  if(url.indexOf('storm://app') === 0) {
    window.location.href = url;
    return;
  } else if (url.indexOf('http') !== 0) {
    console.log(process.env.REACT_APP_DEMAND_URL);
    url = process.env.REACT_APP_DEMAND_URL + '#' + url

  }


  if(!isStorm) {
    window.location.href = url;
  }

	bridge.callHandler('nativeEvent', {
		event: 'pushPage', params: {
			url: Base64.encode(url)
		}
	}, () => { })
}

/**
 * 数据列表上拉加载新数据，然后去重
 * @param { list } 列表数据
 * @param { addList } 加载的新数据
 * @param { key } 判断标识
 */
 export function duplicatePush(list, addList, key) {
  let length1 = list.length
  let length2 = addList.length
  let result = deepClone(list)
  for (var i = 0; i < length2; i ++) {
    for (var j = 0; j < length1; j ++) {
      if (list[length1 - 1 - j][key] === addList[i][key]) {
        break;
      }
    }
    if (j === length1) {
      result.push(addList[i])
    }
  }
  return result
}
/**
 * @param {*} url JS 路径
 * @param {*} onload  调用的方法
 */
 export function _require(url, onload) {
  var doc = document;
  var head = doc.head || (doc.getElementsByTagName("head")[0] || doc.documentElement);
  var node = doc.createElement("script");
  node.onload = onload;
  node.onerror = function () {};
  // node.async = true;
  node.src = url;
  head.appendChild(node)
}
/*
*
* @param {*} type  平台类型
*/
export function initShare (type) {
 // jsapi 地址
 const dingTalkUrl = process.env.REACT_APP_DOWN_URL +  'app/jsapi/dingtalk.open.js'
 const qqUrl = process.env.REACT_APP_DOWN_URL +  'app/jsapi/qqapi.js'
 // const weiboUrl = process.env.downDemandUrl +  'app/jsapi/wbsdk.js'
 const weixinUrl = process.env.REACT_APP_DOWN_URL +  'app/jsapi/jweixin-1.4.0.js'
 switch (type) {
	 case 'qq':
		 _require(qqUrl, ()=>{})
		 break;
		 case 'weixin':
		 _require(weixinUrl, ()=>{})
		 break;
		 case 'dingtalk':
			 _require(dingTalkUrl, ()=>{})
		 break;
		 // case 'weibo':
		 //   _require(weiboUrl, ()=>{})
		 // break;
		 default:
		 break
 }
}

/**
 * 将 PEM 格式的公钥转换为 ArrayBuffer
 */
function pemToArrayBuffer(pem) {
  const b64 = pem
    .replace('-----BEGIN PUBLIC KEY-----', '')
    .replace('-----END PUBLIC KEY-----', '')
    .replace(/\s/g, '');
  
  const binaryString = atob(b64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

/**
 * 使用 Web Crypto API 进行 RSA 加密
 */
async function rsaEncryptWithWebCrypto(text, publicKeyPem) {
  try {
    // 导入公钥
    const publicKey = await crypto.subtle.importKey(
      'spki',
      pemToArrayBuffer(publicKeyPem),
      {
        name: 'RSA-OAEP',
        hash: 'SHA-1',
      },
      false,
      ['encrypt']
    );

    // 加密数据
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    
    const encrypted = await crypto.subtle.encrypt(
      {
        name: 'RSA-OAEP',
      },
      publicKey,
      data
    );

    // 转换为 base64
    const encryptedArray = new Uint8Array(encrypted);
    let binary = '';
    for (let i = 0; i < encryptedArray.byteLength; i++) {
      binary += String.fromCharCode(encryptedArray[i]);
    }
    return btoa(binary);
  } catch (error) {
    console.error('RSA encryption error:', error);
    throw error;
  }
}

// export async function rsaString(text) {
//   const publicKey = "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAx6Cu1q/suUGyXQMALQoTY2kK2rybWdkeNLjhZPJZRjShXWoYWCdly04HxhQC3WV+fZOu64WYOwBQaoKnGX1Ten1lByVgo/u0q4vZwAj5axHwmMq7LkebWWeVC54DCfANUegL9nthXkoJJe0SsNflEinzjWSUwHjQkQeOBMq8wODXakvyJPwwb/PU29QPlKQfNxgM/44K4U1ZTvZUFgSYVtIx6/1W3by7FSoCr3Ik988ptbq1ruhPtxW7x1bjQbTLayLPD2CYDOL2/px+8hypMbXUXSmYcur5ulSLVhZ73btret7xz0gjFZCXePn7OR/6I9CtF/PztA229baXIwZE2wIDAQAB-----END PUBLIC KEY-----";

//   try {
//     const encrypted = await rsaEncryptWithWebCrypto(text, publicKey);
//     return encrypted;
//   } catch (error) {
//     console.error('Encryption failed:', error);
//     throw error;
//   }
// }

export function rsaString(text) {
  var priK = "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAx6Cu1q/suUGyXQMALQoTY2kK2rybWdkeNLjhZPJZRjShXWoYWCdly04HxhQC3WV+fZOu64WYOwBQaoKnGX1Ten1lByVgo/u0q4vZwAj5axHwmMq7LkebWWeVC54DCfANUegL9nthXkoJJe0SsNflEinzjWSUwHjQkQeOBMq8wODXakvyJPwwb/PU29QPlKQfNxgM/44K4U1ZTvZUFgSYVtIx6/1W3by7FSoCr3Ik988ptbq1ruhPtxW7x1bjQbTLayLPD2CYDOL2/px+8hypMbXUXSmYcur5ulSLVhZ73btret7xz0gjFZCXePn7OR/6I9CtF/PztA229baXIwZE2wIDAQAB-----END PUBLIC KEY-----";

  const key = new NodeRSA(priK)
  //  设置协议
  key.setOptions({ encryptionScheme: 'pkcs1'})

  const encrypted = key.encrypt(text, 'base64');
  return encrypted;

}
/**
 * 同步版本的 RSA 加密（返回 Promise，但可以链式调用）
 * 为了保持与旧代码的兼容性
 */
export function rsaStringSync(text) {
  return rsaString(text);
}



export const getObjectFormSerach = (searchStr = '') => {
  if (!searchStr) {
    return {};
  }
  let queryStr = searchStr;
  if (searchStr.startsWith('?')) {
    queryStr = searchStr.slice(1, searchStr.length);
  }
  const queryArr = queryStr.split('&');
  const result = queryArr.reduce((pre, cur) => {
    const next = { ...pre };
    if (/^([^=]+)=([^=]+)$/.test(cur)) {
      const [key, value] = cur.split('=');
      next[key] = value;
    }
    return next;
  }, {});
  return result;
};

const regPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/

export const validPhone = (phoneNum) => {
  return regPhone.test(phoneNum)
}

export let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

export const userBehaver = (parmas = {}) => {
  const defaultParams = {
    activeIdKey: '',
    appType: isiOS ? 1 : 2,
    version: bwmodel.version,
    techType: 3,
    eventType: 4,
    eventTime: new Date().valueOf(),
    conId: ''
  }
  bridge.callHandler('nativeEvent', {
    event: 'userBehaviour',
    params: {...defaultParams, ...parmas}
  }, res => {})
}

export const handleUploadTrace = (id, type, args = {}) => {
  const timestamp = `${new Date().valueOf()}`;
  const event = {
    source: isStorm ? 'inside' : 'outside',
    event: type || 'click',
    eventTime: timestamp,
    type: id
  }
  uploadTrace({
    traceStat: JSON.stringify([event]),
    timestamp: timestamp,
    nonce: id
  })
}

export const popNativePage = (callback) => {
  bridge.callHandler(
    'nativeEvent',
    {
      event: 'popPage',
      params: {
        index: '-1'
      }
    },
    () => {
      callback && callback();
    }
  );
};

export const loadImg = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = url;
    img.onload = () => {
      resolve(img);
    };
    img.onerror = (err) => {
      reject(err);
    };
  });
};

export const drawImg = (url, format = 'png') => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);
      const dataURL = canvas.toDataURL(`image/${format}`);
      resolve(dataURL);
    };
    img.onerror = (err) => {
      reject(err);
    };
  });
};
